import type { FunctionComponent } from 'react';

import CalendarIcon from '@atlaskit/icon/glyph/calendar';
import type { PlannerTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import { ComingSoonSection } from './ComingSoonSection';

import styles from './StubPlanner.less';

export const StubPlanner: FunctionComponent = () => {
  return (
    <>
      <div
        className={styles.planner}
        data-testid={getTestId<PlannerTestIds>('stub-planner')}
      >
        <header className={styles.header}>
          <CalendarIcon label="" size="medium" />
          <span>Planner</span>
        </header>
      </div>
      <ComingSoonSection />
    </>
  );
};
